// extracted by mini-css-extract-plugin
export default {"noteContainer":"NoteContainer_noteContainer__S42uZ"};